import { ComponentProps, memo } from 'react'
import { AccordionSummary as MuiAccordionSummary } from '@mui/material'
import { accordionSummaryStyles as styles } from './AccordionSummary.style'
import { PlusIcon, MinusIcon } from '@/assets'
export interface AccordionSummaryProps extends ComponentProps<typeof MuiAccordionSummary> {}

const AccordionSummary = (props: AccordionSummaryProps) => {
  return (
    <MuiAccordionSummary
      {...props}
      sx={styles.accordionSummaryIconStyles}
      expandIcon={
        <>
          <PlusIcon className="plusIcon" />
          <MinusIcon className="minusIcon" />
        </>
      }
    />
  )
}

export default memo(AccordionSummary)
